import { trigger, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'superflex-card',
    template:`
        <div class="card">
            <h5>{{title}} <help-icon [show]="showHelpIcon"></help-icon></h5>
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

    @Input() title:string = ''
    @Input() showHelpIcon? = false;

    constructor() { }

    ngOnInit(): void {
    }

}
